import ServiceIcon from "../../../vectors/ServiceIconFirm";

const defaultProps = {
  start: 0,
  end: undefined,
  services: [],
  firstName: "",
  ifaAndLimitedForMortgages: false,
};

const ServicesList = ({start, end, services}) => {
    if (!services.length) return null;

    return (
        <ul className="m-0 pl-0 flex-col w-full flex flex-wrap box-border">
            {services.slice(start, end).map((service) => (
                <li className={'flex mb-4 grow-0 w-full [&_svg]:h-6'} key={service.label}>
                    <svg
                        className="p-2 text-[1.6rem] max-h-6 max-w-6 mt-1 border-solid border-[3px] rounded-full fill-primary-blue"
                        viewBox={'0 0 24 24'}
                        aria-hidden={true}
                        focusable={false}
                    >
                        <ServiceIcon name={service.iconId}/>
                    </svg>
                    <div className={'ml-3 self-center'}>
                        <p className="text-[1.2rem] leading-6 m-0">
                            <b className="test-service-name">{service.label}</b>
                        </p>
                    </div>
                </li>
            ))}
        </ul>
    );
};

ServicesList.defaultProps = defaultProps;

export default ServicesList;
